import { render, staticRenderFns } from "./LfsTextBox.vue?vue&type=template&id=77284ae5&scoped=true&"
import script from "./LfsTextBox.vue?vue&type=script&lang=ts&"
export * from "./LfsTextBox.vue?vue&type=script&lang=ts&"
import style0 from "./LfsTextBox.vue?vue&type=style&index=0&id=77284ae5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77284ae5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
